<template>
    <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header
                :title="$T('order') + ' ' + (form.id || '') + ' - ' + (form['order_status.description'] ?
                    form['order_status.description'] : '')"
                icon="find in page">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="fa icon-close"
                              :disable="form.busy"
                              @click.native="close"></v-button>
                </template>
            </v-header>
            <card width="100%">

                <form v-if="mockData && user"
                      class="row gutter-xs"
                      @keydown="form.onKeydown($event)">

                    <v-display v-model="form.created_at"
                               :label="$t('created at')"
                               :form="form"
                               :class="mockData.enable_partner === '1' ? 'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-4 col-sm-6 col-xs-12'">
                    </v-display>

                    <v-display v-model="form['lending_point.description']"
                               :label="$t('lending point')"
                               :form="form"
                               :class="mockData.enable_partner === '1' ? 'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-4 col-sm-6 col-xs-12'">
                    </v-display>

                    <v-display v-model="form['partner.name']"
                               :label="$t('partner')"
                               :form="form"
                               :class="mockData.enable_partner === '1' ? 'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-4 col-sm-6 col-xs-12'"
                               v-if="mockData.enable_partner === '1'">
                    </v-display>

                    <v-autocomplete v-if="orderStatuses['RESERVED'] == form['order_status.description'] &&
                                          ['Courier', 'Lending Point', 'Sales Expert', 'MUPI', 'Remote Coach'].includes(user.role.name)"
                                    path="lending_kit_id"
                                    resource-path="v1/my-available-lending-kits"
                                    key="lending_kit_id"
                                    v-model="form.lending_kit_id"
                                    :label="$t('lending kit')"
                                    :item-plural="$t('lending kits')"
                                    :map="item => ({
                                        label: `${item.product_model.description} ${item.product_color.description}`,
                                        value: item.id,
                                        sublabel: `${this.$T('codentify')}: ${item.codentify}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
                                    })"
                                    :form="form"
                                    :class="mockData.enable_partner === '1' ? 'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-4 col-sm-6 col-xs-12'">
                    </v-autocomplete>

                    <v-display v-else
                               :value="lendingKit"
                               :label="$t('lending kit')"
                               :form="form"
                               :class="mockData.enable_partner === '1' ? 'col-xl-3 col-md-4 col-sm-6 col-xs-12' : 'col-md-4 col-sm-6 col-xs-12'">
                    </v-display>

                    <v-display v-model="form.firstname"
                               :label="$t('first name')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.lastname"
                               :label="$t('last name')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="prefixedPhone"
                               :label="$t('cell phone')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.email"
                               :label="$t('email')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.document_type"
                               :label="$t('document type')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.dni"
                               :label="$t('dni')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="start_lending_at"
                               :label="$t('lending start date')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="end_lending_at"
                               :label="$t('lending end date')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="real_end_lending_at"
                               :label="$t('lending real end date')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.follow_up"
                               :label="$t('follow up')"
                               :inner-label="$T('yes')"
                               :negative-label="$T('no')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 colx-xs-12">
                    </v-display>

                    <v-display v-model="form.birthdate"
                               :label="$t('birth date')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.zipcode"
                               :label="$t('zip code')"
                               :form="form"
                               class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="form.observations"
                               :label="$t('observations')"
                               :form="form"
                               type="textarea"
                               :class="form.delivery != $T('yes') ? 'col-12' : 'col-md-4 col-xs-12'">
                    </v-display>

                    <template v-if="form.delivery == $T('yes')">

                        <v-display v-model="formatedAddress"
                                   :label="$T('delivery address')"
                                   :form="form"
                                   type="textarea"
                                   class="col-md-4 col-xs-12">
                        </v-display>

                        <v-display v-model="formatedPickupAddress"
                                   :label="$T('pickup address')"
                                   :form="form"
                                   type="textarea"
                                   class="col-md-4 col-xs-12">
                        </v-display>

                    </template>

                    <v-radio-buttons v-if="actions.length > 1"
                                     path="action"
                                     v-model="action"
                                     :label="$T('actions')"
                                     :options="actions"
                                     :form="form"
                                     @input="makeActionDataAdjustments"
                                     class="col-12">
                    </v-radio-buttons>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md group">

                        <!-- Change end date 
                        <v-button v-if="orderStatuses['IN_LENDING'] === form['order_status.description'] && !action"
                                  outline
                                  :label="$T('edit end date')"
                                  icon="event_available"
                                  color="info"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click.prevent="changeEndDate">
                        </v-button> -->
                        <v-button v-if="!form['extended_at'] && orderStatuses['IN_LENDING'] === form['order_status.description']"
                                  outline
                                  :label="$T('extend lending')"
                                  icon="event_available"
                                  color="info"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click.prevent="extendLending">
                        </v-button>
                        <v-button v-if="[1, 2, 3, 4, 5].includes(action) &&
                            (orderStatuses['IN_LENDING'] === form['order_status.description'] || orderStatuses['IN_LENDING_DELAYED'] === form['order_status.description'])"
                                  outline
                                  :label="$T('save')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click="moveTo('completed', stockActions.find(a => a.value == stockAction).stockStatus)"
                                  :loading="form.busy"
                                  :disable="form.busy">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                    </div>

                </form>

                <div class="justify-center row layout-padding" v-else>
                    <spinner-iqos size="60px"/>
                </div>

            </card>
        </div>
        <q-modal v-model="modalEndDate" no-backdrop-dismiss no-esc-dismiss>
            <div>
                <v-header>
                    <template slot="right">
                        <v-button flat rounded dense color="primary"
                                  icon="fa icon-close"
                                  :disable="form.busy"
                                  @click.native="cancelEndDate"></v-button>
                    </template>
                </v-header>
                <card width="100%">

                    <form class="row gutter-xs"
                          @keydown="form.onKeydown($event)">

                        <v-datetime path="end_lending_at"
                                    v-model="form.end_lending_at"
                                    :label="$t('lending end date')"
                                    format-data="YYYY-MM-DD"
                                    format="DD-MM-YYYY"
                                    :form="form"
                                    :disable="orderStatuses['IN_LENDING'] !== form['order_status.description']"
                                    class="col-12">
                        </v-datetime>

                        <!-- Submit Button -->
                        <div class="col-12 row justify-center q-mt-md group">

                            <!-- Save changes -->
                            <v-button outline
                                      :label="$T('cancel')"
                                      icon="close"
                                      color="danger"
                                      class="no-shadow uppercase q-btn-iqos"
                                      @click.prevent="cancelEndDate">
                            </v-button>

                            <!-- Save changes -->
                            <v-button v-if="orderStatuses['IN_LENDING'] === form['order_status.description']"
                                      outline
                                      :label="$T('save')"
                                      icon="save"
                                      color="info"
                                      :loading="form.busy"
                                      :disable="form.busy"
                                      class="no-shadow uppercase q-btn-iqos"
                                      @click.prevent="save">
                                <template slot="loading">
                                    <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                    {{ $T('saving...') | capitalize }}
                                </template>
                            </v-button>
                        </div>
                    </form>
                </card>
            </div>
        </q-modal>
    </q-modal>

</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import moment from 'moment'
import axios from 'axios'
import orderModel from '../../orderModel'
import consumerModel from '../../consumerModel'
import {
    QSpinnerPuff,
    QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import VDatetime from '../../../components/form/VDatetime'
import VDisplay from '../../../components/form/VDisplay'

export default {
    mixins: [orderModel, consumerModel],

    components: {
        VDisplay,
        VDatetime,
        QSpinnerPuff,
        QModal
    },

    props: {
        show: Boolean,
        item: {
            type: Object,
            default: {}
        },

    },

    data() {
        return {
            kitWasUsed: false,
            modalEndDate: false,
            createANewOrder: false,
            previousEndValue: null,
            orderStatuses: window.config.orderStatuses,
            stockStatuses: window.config.stockStatuses,
            modalOrder: this.show,
            form: {},
            mockPath: 'v1/order-detail',
            action: 0,
            stockAction: 0,
            mockData: null,
            genderOptions: [
                {value: 3, label: this.$T("gender male")},
                {value: 4, label: this.$T("gender female")}
            ],
            employeeOptions: [{value: "", label: "-"}],
            lendingKit: null,
            start_lending_at: '',
            end_lending_at: '',
            real_end_lending_at: ''
        }
    },

    watch: {
        show(newVal) {
            this.modalOrder = newVal
        },

        item(newItem) {
            this.form = new Form(Object.assign(deepCopy(this.orderModel), newItem))
            //this.form.birthdate = this.form.birthdate ? moment(this.form.birthdate).format('DD-MM-YYYY') : ''
            //this.lendingKit = `${this.form['lending_kit.product_model.description']} ${this.form['lending_kit_product_color.description']}`
            this.lendingKit = this.form['lending_kit.codentify']
            this.start_lending_at = this.startLendingAt
            this.end_lending_at = this.endLendingAt
            this.real_end_lending_at = this.realEndLendingAt
            this.form.closed_by_backoffice = true
            this.getMockData()
        }
    },

    methods: {

        close() {
            this.action = 0
            this.stockAction = 0
            this.modalOrder = false
            this.modalEndDate = false
            this.$emit('close')
        },

        async getMockData() {
            this.mockData = null
            const {data} = await axios.get(`${config.appUrl}/api/${this.mockPath}/form-mock-data/${this.item.id || ''}`)
            this.mockData = data.data

            if (this.form['lending_kit.id']) {
                let lendingKit = await axios.get(`${config.appUrl}/api/lending-kit/${this.form['lending_kit.id']}`)
                if (lendingKit.data.kit_uses > 0) this.$set(this, 'kitWasUsed', true)
                lendingKit = lendingKit.data.model
                let product_color = await axios.get(`${config.appUrl}/api/product-color/${lendingKit.product_color_id}`)
                let product_model = await axios.get(`${config.appUrl}/api/product-model/${lendingKit.product_model_id}`)
                lendingKit.product_color = product_color.data.model
                lendingKit.product_model = product_model.data.model
                this.mockData.lendingKits = [lendingKit]

            }
        },

        makeActionDataAdjustments(action) {
            if ([1, 2, 3].includes(action)) {
                this.form.pickup_address = this.form.address
                this.form.pickup_address_2 = this.form.address_2
                this.form.pickup_zipcode = this.form.zipcode
                this.form.pickup_city = this.form.city
            }

            if ([1].includes(action)) {
                this.form.is_sold = 0
                this.stockAction = 0
                this.form.no_sold_reason_id = this.mockData.noSoldReasons.id
            }

            if ([2].includes(action)) {
                this.form.is_sold = 1
                this.stockAction = 14
                this.form.no_sold_reason_id = null
            }

            if ([3].includes(action)) {
                this.form.is_sold = 0
                this.form.no_sold_reason_id = null
            }

            if ([4].includes(action)) {
                this.form.is_sold = 2
                this.stockAction = 0
                this.form.no_sold_reason_id = null
            }

            if ([5].includes(action)) {
                this.form.is_sold = 0
                this.stockAction = 13
                this.form.no_sold_reason_id = null
            }
        },

        async save() {
            await this.form.patch(`${window.config.appUrl}/api/v1/order`)
                .then(({data}) => {
                    this.close()
                    this.$emit('updated')

                    this.$q.dialog({
                        title: this.$T('success'),
                        message: data.success.message,
                        preventClose: true,
                        stackButtons: false,
                        ok: {
                            label: this.$T('close'),
                            outline: true,
                            rounded: true,
                            color: 'primary',
                            noCaps: true
                        },
                    })
                })
                .catch(response => console.log(response))
        },

        async moveTo(orderStatus, stockStatus = '') {
            //if the action is marked as "vendido" the alert should be appear
            /*if ([2, 6].includes(this.action) && this.kitWasUsed) {
                this.$q.dialog({
                    title: this.$T('warning'),
                    message: this.$T('this kit is used and not valid for sale'),
                    preventClose: true,
                    stackButtons: false,
                    ok: {
                        label: this.$T('close'),
                        outline: true,
                        rounded: true,
                        color: 'primary',
                        noCaps: true
                    },
                })
                return;
            }*/

            let greenGo = true

            //Set form to busy
            this.form.busy = true

            // Shorthand
            let role = this.user.role.name

            // Is sold?
            let isSold = this.action != 1 && this.action != 3 && this.action != 5

            //if the action is marked as "préstamo defactuoso" the stockStatus should be Roto
            if (this.action === 3) {
                stockStatus = 'broken'
                orderStatus = 'broked'
            }

            if (this.action === 5) {
                orderStatus = 'not_returned'
            }

            if (greenGo) {
                let limpiezaKitEnabled = false
                this.user.market.configurations.filter(config => {
                    if (config.description === 'enable_kit_clean') limpiezaKitEnabled = !!(parseInt(config.pivot.value))
                })
                if (limpiezaKitEnabled && stockStatus === 'available') stockStatus = 'clear'

                this.form.isSold = isSold
                await this.form.post(`${this.baseUrl}/order/${this.form.id}/move-to/${orderStatus}/${stockStatus}`)
                    .then(({data}) => {
                        this.close()
                        this.$emit('updated')
                        /*this.$q.dialog({
                            title: this.$T('success'),
                            message: data.success.message,
                            preventClose: true,
                            stackButtons: false,
                            ok: {
                                label: this.$T('close'),
                                outline: true,
                                rounded: true,
                                color: 'primary',
                                noCaps: true
                            },
                        }).then(() => {
                        })*/
                       //console.log(data);
                       if(data.registroRedirect === true){
                                const baseUrl = window.config.registroWS+'/api/register-sale';
                                const params = new URLSearchParams({
                                    source: data.source,
                                    auth: data.auth,
                                    token: data.token,
                                    payload: data.payload,
                                    pos: data.pos
                                });

                                const url = `${baseUrl}?${params.toString()}`;
                                window.location.href = url;
                            }
                    })
                    .catch(response => console.log(response))
            }
        },

        changeEndDate() {
            this.modalEndDate = true
            this.previousEndValue = this.form.end_lending_at
        },

        cancelEndDate() {
            this.modalEndDate = false
            this.form.end_lending_at = this.previousEndValue
        },

        async extendLending() {
            await this.save()
        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),

        baseUrl() {
            return `${window.config.appUrl}/api/v1/lending-point`
        },

        startLendingAt() {
            if (!this.form.start_lending_at)
                return this.$T('not started yet')
            return moment(this.form.start_lending_at).format('DD-MM-YYYY')
        },

        endLendingAt() {
            if (!this.form.end_lending_at && !this.form.start_lending_at)
                return this.$_T(':days days after start', {days: this.mockData.lendingDays})
            else if (this.form.start_lending_at && !this.form.end_lending_at)
                return moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
                    .format('DD-MM-YYYY') + ' - ' + this.$T('planned')
            return moment(this.form.end_lending_at).format('DD-MM-YYYY')
        },

        realEndLendingAt() {
            if (!this.form.real_end_lending_at)
                return 'N.A.'
            return moment(this.form.real_end_lending_at).format('DD-MM-YYYY')
        },

        prefixedPhone() {
            let prefix = this.form.phone_prefix === '00' || !this.form.phone_prefix ? this.form.phone_prefix : this.form.phone_prefix.replace('00', '+')
            return this.form.phone ? `${prefix} ${this.form.phone}` : ''
        },

        formatedAddress() {
            if (this.form.address)
                return this.form.address + ', ' +
                    (this.form.address_2 ? this.form.address_2 + ', ' : '') +
                    this.form.city + '. ' +
                    this.$T('zip code') + ': ' + this.form.zipcode
            return ''
        },

        formatedPickupAddress() {
            if (this.form.pickup_address)
                return this.form.pickup_address + ', ' +
                    (this.form.pickup_address_2 ? this.form.pickup_address_2 + ', ' : '') +
                    this.form.pickup_city + '. ' +
                    this.$T('zip code') + ': ' + this.form.pickup_zipcode
            return ''
        },

        actions() {
            let orderStatus = this.form['order_status.description']
            let orderStatuses = this.orderStatuses

            let actions = [{value: 0, label: this.$T('no action')}]

            // Lending Point
            if (orderStatus == orderStatuses['IN_LENDING']) {
                actions = actions.concat([
                    {value: 1, label: `${this.$T('completed')} <strong>&gt; ${this.$T('no sold')}</strong>`},
                ])

                if (this.mockData.optionSoldDifferentKit === "1") {
                    actions = actions.concat([
                        {
                            value: 4,
                            label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold a different lending kit')}</strong>`
                        },
                    ])
                }

                // And on lending point the configuration is 'ON'
                if (this.mockData.enable_completed_sold && this.mockData.enable_completed_sold === 1) {
                    actions = actions.concat([
                        {value: 2, label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold')}</strong>`}
                    ])
                } else {
                    actions = actions.concat([
                        {value: 2, label: `${this.$T('completed')} <strong>&gt; ${this.$T('sold')}</strong>`}
                    ])
                }

                actions = actions.concat([
                    {value: 3, label: `${this.$T('defective order')} `},
                ])

                actions = actions.concat([
                    {
                        value: 5,
                        label: `${this.$T('order not returned')}</strong>`
                    },
                ])
            }

            return actions
        },

        stockActions() {
            let role = this.user.role.name
            let orderStatus = this.form['order_status.description']
            let orderStatuses = this.orderStatuses

            let actions = [{value: 0, label: this.$T('no action')}]

            if (orderStatus == orderStatuses['IN_LENDING'] && role == 'Backoffice')
                actions = [
                    {
                        value: 0,
                        stockStatus: 'available',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('to available')}</strong>`
                    },
                    {
                        value: 11,
                        stockStatus: 'broken',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('broken')}</strong>`
                    },
                    {
                        value: 13,
                        stockStatus: 'not-returned',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('not returned')}</strong>`
                    },
                    {
                        value: 14,
                        stockStatus: 'sold',
                        label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('sold')}</strong>`
                    }
                ]

            return actions
        },

        canRegisterConsumer() {
            return this.action == 2 && ['Call Center', 'Lending Point', 'Sales Expert', 'MUPI', 'Remote Coach'].includes(this.user.role.name)
        },

        maxBirthDate() {
            return moment().subtract(18, 'years').format('YYYY-MM-DD\THH:mm:ss.SSSZ')
        }
    },

    created() {
        if (!this.mockData) {
            this.getMockData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/order/_orderDetail.vue